import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ProductCategoryDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, ProductCategoryDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.PRODUCT_CATEGORIES,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [{ type: 'product-categories-with-join', id: 'GET-JOIN' }],
    });
